import { API } from "aws-amplify";
import { createOffer } from "~/graphql/mutations";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

const EMPTY_OFFER: APITypes.Offer = {
  id: "",
  startDate: "",
  endDate: "",
  tenantSignDate: "",
  landlordSignDate: "",
  __typename: "Offer",
  status: APITypes.OfferStatusType.Pending,
  createdAt: "",
  updatedAt: "",
  rent: 0,
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const addOffer = async (
  payload: APITypes.CreateOfferInput
): Promise<LoaderData<APITypes.Offer>> => {
  try {
    const newOffer = await API.graphql({
      query: createOffer,
      variables: {
        input: {
          startDate: payload.startDate,
          status: APITypes.OfferStatusType.Pending,
          rent: payload.rent,
        },
      },
    });
    return {
      success: true,
      //@ts-ignore
      data: newOffer.data.createOffer,
    };
  } catch (error) {
    console.error("error adding pending offer", error);
    return {
      success: false,
      data: EMPTY_OFFER,
      error,
    };
  }
};
